<template>
  <div id="winnerAnnouncement">
    <div class="overlay">
      <p v-html="$t('promotion.luckyDraw.congrats')"></p>
      <el-button type="primary" class="blue_button" size="medium" @click="showDialog" data-testid="viewWinner">{{
        $t('promotion.luckyDraw.viewWinnerList')
      }}</el-button>
    </div>
    <!-- <img class="banner" src="@/assets/images/promotion/luckyDraw/winner.png" /> -->
    <!-- winner list dialog -->

    <el-dialog
      id="dialog_table"
      width="810px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <p class="text-center my-5" v-html="$t('promotion.luckyDraw.winnerList')"></p>
      <el-table :data="winnerData" stripe style="width: 100%">
        <el-table-column prop="prize" :label="$t('promotion.luckyDraw.prize')"> </el-table-column>
        <el-table-column prop="item" :label="$t('promotion.luckyDraw.item')"> </el-table-column>
        <el-table-column prop="winners" :label="$t('promotion.luckyDraw.winners')" width="360"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    winnerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      winnerData: undefined
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    }
  },
  mounted() {
    this.winnerData = this.winnerList.map(prize => {
      return {
        prize: this.$t(`promotion.luckyDraw.prizes.${prize.rank + 1}`),
        item: prize.selectedPrizeName,
        winners: prize.winnerName.join(', ')
      };
    });
  }
};
</script>

<style lang="scss" scoped>
#winnerAnnouncement {
  position: relative;
  display: flex;
  background: #f9f9f9;
  border-radius: 10px;
  overflow: hidden;

  /deep/ .orange-text {
    color: #000;
  }

  /deep/ .el-dialog {
    margin-top: unset !important;
  }

  .overlay {
    z-index: 10;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    backdrop-filter: blur(5px);
    border-radius: 10px;
    padding: 30px;
    gap: 20px;

    & > p {
      font-size: 32px;
      font-weight: 500;
      color: $title-color;
    }
  }
  .banner {
    position: absolute;
    opacity: 50%;
    bottom: 0;
  }
}

#dialog_table /deep/ {
  .el-table th.el-table__cell {
    background: #e26127 !important;
  }

  .el-table thead .cell {
    color: white !important;
  }
  tbody {
    .cell {
      color: #87878b;
      font-weight: 400;
      // font-size: 14px;
    }
    tr:nth-child(2n) {
      background-color: #f5f5f5;
      border-top-right-radius: 0rem;
    }
  }
  .el-table .active-row {
    .cell {
      color: black !important;
      font-weight: 800;
    }
  }

  .el-table {
    height: 600px;
    overflow-y: scroll;
  }

  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    content: none;
  }
}

@media (max-width: 1024px) {
  #winnerAnnouncement {
    margin: 8px;
  }
}
</style>
